"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const faCircleInfo_1 = require("@fortawesome/pro-light-svg-icons/faCircleInfo");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const switch_1 = require("components/cosmos/switch");
const tooltip_1 = __importDefault(require("components/cosmos/tooltip"));
const helper_1 = require("components/cosmos/tooltip/helper");
const translate_1 = require("components/translate");
const useModal_1 = require("hooks/useModal");
const mobx_react_1 = require("mobx-react");
const constants_1 = require("modules/classManager/constants");
const ModalClass_1 = __importDefault(require("modules/classManager/modalClass/ModalClass"));
const DefaultClassToggle = ({ t, classId, isChecked, isDefaultClass, isMobile = false, onChange }) => {
    const [modalType, setModalType] = (0, react_1.useState)();
    const { isModalOpen, handleClose, handleOpen } = (0, useModal_1.useModal)();
    const titleTooltip = t('class_manager.class_editor.default_class_tooltip', {
        checkOnlineEvent: true
    });
    const positionTooltip = (0, helper_1.setPosition)(tooltip_1.default.TOOLTIP_POSITION.TOP, tooltip_1.default.TOOLTIP_POSITION.RIGHT, isMobile);
    const handleChange = ({ target }) => {
        if (classId && isDefaultClass) {
            setModalType(constants_1.modalTypes.setCommonClass.type);
            handleOpen();
        }
        else if (target.checked) {
            setModalType(constants_1.modalTypes.setDefaultClass.type);
            handleOpen();
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange();
        }
    };
    const handleModalConfirm = () => {
        onChange === null || onChange === void 0 ? void 0 : onChange();
        handleClose();
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(switch_1.Switch, { id: "defaultClassToggle", isChecked: isChecked, onChange: handleChange, "data-test": "toggle", children: (0, jsx_runtime_1.jsx)(translate_1.I18n, { label: constants_1.DEFAULT_CLASS.INFO, checkOnlineEvent: true }) }), (0, jsx_runtime_1.jsx)(tooltip_1.default, { content: titleTooltip, position: positionTooltip, className: "_ml-2 _pr-1", children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faCircleInfo_1.faCircleInfo }) }), isModalOpen && modalType && ((0, jsx_runtime_1.jsx)(ModalClass_1.default, { type: modalType, onCancel: handleClose, onConfirm: handleModalConfirm }))] }));
};
exports.default = (0, mobx_react_1.inject)((store) => ({
    isMobile: store.UiStore.isMobile
}))((0, translate_1.translate)()(DefaultClassToggle));
